(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.Currency && window.Currency.format) || '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }

    var amount = Number(cents || 0) / 100;
    return '$' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function moneyMarkup(currentPrice, originalPrice, className) {
    var current = Number(currentPrice || 0);
    var original = Number(originalPrice || current);
    var isDiscounted = original > current;
    var baseClass = className || 'bioss-cart-drawer__item-price';
    var drawer = document.querySelector('[data-bioss-cart-drawer]');
    var freeLabel = drawer && drawer.getAttribute('data-bioss-cart-free-label');
    var currentLabel = current === 0 && freeLabel ? freeLabel : formatMoney(current);

    if (!isDiscounted) {
      return '<strong class="' + baseClass + '">' + escapeHtml(currentLabel) + '</strong>';
    }

    return [
      '<strong class="' + baseClass + ' bioss-cart-drawer__price-stack">',
        pricePartsMarkup(current, original, currentLabel),
      '</strong>'
    ].join('');
  }

  function pricePartsMarkup(currentPrice, originalPrice, currentLabel) {
    var current = Number(currentPrice || 0);
    var original = Number(originalPrice || current);

    if (original <= current) {
      return '<span>' + escapeHtml(formatMoney(current)) + '</span>';
    }

    return [
      '<span class="bioss-cart-drawer__price-was">' + escapeHtml(formatMoney(original)) + '</span>',
      '<span>' + escapeHtml(currentLabel || formatMoney(current)) + '</span>'
    ].join('');
  }

  function getLinePrices(item) {
    var quantity = Number(item.quantity || 1);
    var current;
    var original;

    if (typeof item.final_line_price === 'number') {
      current = item.final_line_price;
    } else if (typeof item.final_price === 'number') {
      current = item.final_price * quantity;
    } else if (typeof item.line_price === 'number') {
      current = item.line_price;
    } else if (typeof item.price === 'number') {
      current = item.price * quantity;
    } else {
      current = 0;
    }

    if (typeof item.original_line_price === 'number') {
      original = item.original_line_price;
    } else if (typeof item.original_price === 'number') {
      original = item.original_price * quantity;
    } else {
      original = current;
    }

    return {
      current: current,
      original: original
    };
  }

  function renderSubtotal(cart) {
    var current = Number(cart.total_price || 0);
    var original = Number(cart.original_total_price || current);

    return pricePartsMarkup(current, original);
  }

  var cartImageMap = null;
  var fetchedProductImages = {};

  function normalizeImageUrl(url) {
    var value = String(url || '').trim();
    if (!value) return '';
    value = value.replace(/\\\//g, '/');
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.indexOf('http://') === 0) return value.replace('http://', 'https://');
    return value;
  }

  function readCartImageMap() {
    if (cartImageMap) return cartImageMap;

    cartImageMap = {
      items: {},
      variants: {},
      products: {}
    };

    var source = document.querySelector('[data-bioss-cart-drawer-image-map]');
    if (!source) return cartImageMap;

    try {
      var parsed = JSON.parse(source.textContent || '{}');
      cartImageMap.items = parsed.items || {};
      cartImageMap.variants = parsed.variants || {};
      cartImageMap.products = parsed.products || {};
    } catch (error) {
      cartImageMap = {
        items: {},
        variants: {},
        products: {}
      };
    }

    return cartImageMap;
  }

  function mappedCartImage(item) {
    var map = readCartImageMap();
    var itemKey = item && item.key ? String(item.key) : '';
    var variantId = item && item.variant_id ? String(item.variant_id) : '';
    var productId = item && item.product_id ? String(item.product_id) : '';

    return (itemKey && map.items[itemKey]) ||
      (variantId && map.variants[variantId]) ||
      (productId && map.products[productId]) ||
      {};
  }

  function hiddenPropertyImage(item) {
    var properties = (item && item.properties) || {};
    return normalizeImageUrl(properties._bioss_cart_image || properties._cart_image || '');
  }

  function getCartImage(item) {
    var mapped = mappedCartImage(item);
    var image = normalizeImageUrl(
      (item && item.image) ||
      hiddenPropertyImage(item) ||
      (mapped && mapped.url) ||
      (item && item.featured_image && item.featured_image.url) ||
      ''
    );

    return {
      src: image,
      alt: (mapped && mapped.alt) || (item && (item.product_title || item.title)) || 'Bioss product'
    };
  }

  function getProductImageEndpoint(item) {
    var url = item && item.url ? String(item.url) : '';
    var match = url.match(/\/products\/([^/?#]+)/i);
    if (!match || !match[1]) return '';
    return '/products/' + match[1] + '?view=card-images';
  }

  function baseProductHandleFromSku(sku) {
    var text = String(sku || '').trim().toLowerCase();
    var match = text.match(/\b((?:bsm|bsk|bio|bs|ak|cs)-?\d+[a-z]*)/i);
    if (!match || !match[1]) return '';
    return match[1].replace(/^-+|-+$/g, '');
  }

  function getProductImageEndpoints(item) {
    var endpoints = [];
    var productEndpoint = getProductImageEndpoint(item);
    var baseHandle = baseProductHandleFromSku(item && item.sku);
    var baseEndpoint = baseHandle ? '/products/' + baseHandle + '?view=card-images' : '';

    [productEndpoint, baseEndpoint].forEach(function (endpoint) {
      if (endpoint && endpoints.indexOf(endpoint) === -1) endpoints.push(endpoint);
    });

    return endpoints;
  }

  function cleanOption(value) {
    var text = String(value || '').trim();
    if (!text || /^default title$/i.test(text)) return '';
    return text;
  }

  function getSizeLabel(item) {
    var optionValues = [];

    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (option) {
        var name = String(option.name || '').toLowerCase();
        if (name.indexOf('size') >= 0 || name.indexOf('concentration') >= 0 || name.indexOf('amount') >= 0 || name.indexOf('volume') >= 0) {
          optionValues.push(option.value);
        }
      });
    }

    if (!optionValues.length && Array.isArray(item.variant_options)) {
      optionValues = item.variant_options.slice();
    }

    if (item.variant_title && !optionValues.length) {
      optionValues.push(item.variant_title);
    }

    var cleanValues = optionValues.map(cleanOption).filter(Boolean);
    return cleanValues.length ? cleanValues.join(' / ') : '';
  }

  function getProperties(item) {
    var properties = item.properties || {};
    return Object.keys(properties)
      .filter(function (key) {
        return key.charAt(0) !== '_' && cleanOption(properties[key]);
      })
      .map(function (key) {
        return {
          name: key,
          value: cleanOption(properties[key])
        };
      });
  }

  function fallbackImageMarkup(title) {
    var drawer = document.querySelector('[data-bioss-cart-drawer]');
    var src = normalizeImageUrl(drawer && drawer.getAttribute('data-bioss-cart-fallback-image'));

    if (!src) return '';

    return '<img class="bioss-cart-drawer__fallback-logo" src="' + escapeHtml(src) + '" alt="Bioss logo placeholder for ' + escapeHtml(title) + '" loading="lazy">';
  }

  function renderItem(item) {
    var title = item.product_title || item.title || 'Bioss product';
    var url = item.url || '/cart';
    var imageData = getCartImage(item);
    var size = getSizeLabel(item);
    var properties = getProperties(item);
    var linePrices = getLinePrices(item);
    var imageEndpoints = getProductImageEndpoints(item);
    var imageMarkup = imageData.src
      ? '<a class="bioss-cart-drawer__image-link" href="' + escapeHtml(url) + '"><img src="' + escapeHtml(imageData.src) + '" alt="' + escapeHtml(imageData.alt || title) + '" loading="lazy"></a>'
      : '<div class="bioss-cart-drawer__image-placeholder" data-bioss-cart-image-placeholder data-bioss-cart-item-key="' + escapeHtml(item.key || '') + '" data-bioss-cart-product-images="' + escapeHtml(JSON.stringify(imageEndpoints)) + '">' + fallbackImageMarkup(title) + '</div>';
    var propertyMarkup = properties.map(function (property) {
      return '<p class="bioss-cart-drawer__item-property">' + escapeHtml(property.name) + ': <span>' + escapeHtml(property.value) + '</span></p>';
    }).join('');

    return [
      '<article class="bioss-cart-drawer__item">',
        imageMarkup,
        '<div class="bioss-cart-drawer__item-content">',
          '<a class="bioss-cart-drawer__item-title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>',
          size ? '<p class="bioss-cart-drawer__item-meta">Size: <span>' + escapeHtml(size) + '</span></p>' : '',
          propertyMarkup,
          '<div class="bioss-cart-drawer__item-row">',
            '<span>Qty ' + escapeHtml(item.quantity || 1) + '</span>',
            moneyMarkup(linePrices.current, linePrices.original, 'bioss-cart-drawer__item-price'),
          '</div>',
        '</div>',
      '</article>'
    ].join('');
  }

  ready(function () {
    var cartButton = document.getElementById('CartButton');
    var drawer = document.querySelector('[data-bioss-cart-drawer]');
    var overlay = document.querySelector('[data-bioss-cart-drawer-overlay]');
    var closeButton = document.querySelector('[data-bioss-cart-drawer-close]');
    var status = document.querySelector('[data-bioss-cart-drawer-status]');
    var itemsTarget = document.querySelector('[data-bioss-cart-drawer-items]');
    var emptyTarget = document.querySelector('[data-bioss-cart-drawer-empty]');
    var subtotalTarget = document.querySelector('[data-bioss-cart-drawer-subtotal]');
    var cartCount = document.getElementById('CartCount');
    var isOpen = false;

    if (!cartButton || !drawer || !overlay || !closeButton || !itemsTarget || !emptyTarget || !subtotalTarget) {
      return;
    }

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function replacePlaceholderImage(placeholder, image) {
      var src = normalizeImageUrl(image && image.src);
      if (!placeholder || !src) return;

      var article = placeholder.closest ? placeholder.closest('.bioss-cart-drawer__item') : null;
      var titleLink = article ? article.querySelector('.bioss-cart-drawer__item-title') : null;
      var title = titleLink ? titleLink.textContent : 'Bioss product';
      var href = titleLink ? titleLink.getAttribute('href') : '/cart';
      var alt = image.alt || title;
      var link = document.createElement('a');
      var img = document.createElement('img');

      link.className = 'bioss-cart-drawer__image-link';
      link.href = href || '/cart';
      img.src = src;
      img.alt = alt;
      img.loading = 'lazy';
      link.appendChild(img);
      placeholder.parentNode.replaceChild(link, placeholder);
    }

    function getPlaceholderEndpoints(placeholder) {
      var raw = placeholder.getAttribute('data-bioss-cart-product-images') || '';
      var endpoints = [];

      try {
        endpoints = JSON.parse(raw);
      } catch (error) {
        endpoints = raw ? [raw] : [];
      }

      if (!Array.isArray(endpoints)) endpoints = endpoints ? [endpoints] : [];

      return endpoints.filter(function (endpoint, index) {
        return endpoint && endpoints.indexOf(endpoint) === index;
      });
    }

    function firstImageFromData(data) {
      var images = data && Array.isArray(data.images) ? data.images : [];
      return images.length ? images[0] : null;
    }

    function fetchProductImageData(endpoint) {
      if (Object.prototype.hasOwnProperty.call(fetchedProductImages, endpoint)) {
        return Promise.resolve(fetchedProductImages[endpoint]);
      }

      return fetch(endpoint, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'force-cache'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product image request failed');
          return response.json();
        })
        .then(function (data) {
          fetchedProductImages[endpoint] = data || {};
          return fetchedProductImages[endpoint];
        })
        .catch(function () {
          fetchedProductImages[endpoint] = {};
          return fetchedProductImages[endpoint];
        });
    }

    function hydratePlaceholderImage(placeholder, endpoints, index) {
      if (!placeholder || !placeholder.parentNode || index >= endpoints.length) return;

      fetchProductImageData(endpoints[index]).then(function (data) {
        var image = firstImageFromData(data);

        if (image) {
          replacePlaceholderImage(placeholder, image);
          return;
        }

        hydratePlaceholderImage(placeholder, endpoints, index + 1);
      });
    }

    function hydrateMissingImages() {
      var placeholders = itemsTarget.querySelectorAll('[data-bioss-cart-image-placeholder]');

      Array.prototype.forEach.call(placeholders, function (placeholder) {
        var endpoints = getPlaceholderEndpoints(placeholder);
        if (!endpoints.length) return;
        hydratePlaceholderImage(placeholder, endpoints, 0);
      });
    }

    function renderCart(cart) {
      var items = Array.isArray(cart.items) ? cart.items : [];
      itemsTarget.innerHTML = items.map(renderItem).join('');
      hydrateMissingImages();
      emptyTarget.classList.toggle('is-visible', items.length === 0);
      subtotalTarget.innerHTML = renderSubtotal(cart);
      if (cartCount) cartCount.textContent = cart.item_count || 0;
      setStatus('');
    }

    function refreshCart() {
      setStatus('Loading cart...');
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        })
        .catch(function () {
          setStatus('Cart could not load. Please continue to the shopping cart.');
        });
    }

    function openDrawer() {
      isOpen = true;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bioss-cart-drawer-open');
      refreshCart();
      window.setTimeout(function () {
        closeButton.focus();
      }, 80);
    }

    function closeDrawer() {
      isOpen = false;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bioss-cart-drawer-open');
      setStatus('');
    }

    cartButton.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
        return;
      }

      event.preventDefault();
      openDrawer();
    });

    closeButton.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && isOpen) closeDrawer();
    });

    if (window.StyleHatch && typeof window.StyleHatch.updateCartButton === 'function') {
      var originalUpdateCartButton = window.StyleHatch.updateCartButton;
      window.StyleHatch.updateCartButton = function (cartData) {
        originalUpdateCartButton.apply(this, arguments);
        if (cartData && cartCount) cartCount.textContent = cartData.item_count || 0;
        if (isOpen) refreshCart();
      };
    }

    window.BiossCartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshCart
    };
  });
})();
